import BN from 'bn.js';
import React from 'react';
import { EipError } from 'src/redux/types';
import { useTypedSelector } from 'src/redux/utils';
import { approveContract, getAllowance } from 'src/utils/ethereum';

const useCheckAllowance = ({
  contractAddress,
  thresholdPrice
}) => {
  const userAddress = useTypedSelector(state => {
    var _state$userProfile$us;

    return (_state$userProfile$us = state.userProfile.user) === null || _state$userProfile$us === void 0 ? void 0 : _state$userProfile$us.address;
  });
  const [isEnoughAllowance, setIsEnoughAllowance] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const approveUseBalance = React.useCallback(async () => {
    if (userAddress && thresholdPrice) {
      setIsProcessing(true);
      const result = await approveContract(userAddress, thresholdPrice, contractAddress);

      if (result.error === EipError.NO_ERROR) {
        setIsEnoughAllowance(true);
      }

      setIsProcessing(false);
      return result;
    }

    return {
      error: EipError.NO_ERROR
    };
  }, [contractAddress, thresholdPrice, userAddress]);
  React.useEffect(() => {
    const checkAllowance = async () => {
      if (userAddress && thresholdPrice) {
        setIsProcessing(true);
        const {
          allowance
        } = await getAllowance({
          fromAddress: userAddress,
          contractAddress: contractAddress,
          token: thresholdPrice.token
        });
        const allowanceBN = new BN((allowance === null || allowance === void 0 ? void 0 : allowance.value) || '0');
        const thresholdPriceBN = new BN(thresholdPrice.value);

        if (allowanceBN.gte(thresholdPriceBN)) {
          setIsEnoughAllowance(true);
        } else {
          setIsEnoughAllowance(false);
        }

        setIsProcessing(false);
      }
    };

    checkAllowance();
  }, [contractAddress, thresholdPrice, thresholdPrice === null || thresholdPrice === void 0 ? void 0 : thresholdPrice.token, thresholdPrice === null || thresholdPrice === void 0 ? void 0 : thresholdPrice.value, userAddress]);
  return {
    isEnoughAllowance,
    approveUseBalance: approveUseBalance,
    isProcessing
  };
};

export default useCheckAllowance;